export default class Consumivel {
  constructor() {
    this.id = 0;
    this.descricao = "";
    this.fabricante = "";
    this.tipo = "";
    this.cor = "";
    this.concentracao = "";
    this.veiculo = "";
    this.lote = "";
    this.data = new Date();
    this.validade = new Date();
  }
}
